const configuredMaxLength = Number(import.meta.env.VITE_ALERT_PROCESS_CONTENT_MAX_LENGTH)

export const ALERT_PROCESS_CONTENT_MAX_LENGTH = (
    Number.isInteger(configuredMaxLength) && configuredMaxLength > 0
        ? configuredMaxLength
        : 500
)
